import * as angular from 'angular';
import UsersService from "./users.service";
import UsersInvitation from "./invitation/users.invitation";
import UsersDetails from "./details/users.details";
import UsersEdit from "./edit/users.edit";
import UsersAlert from "./alert/users.alert";
import UsersInviteExist from "./invite/exist/users.invite.exist";
import UsersInviteNew from "./invite/new/users.invite.new";
import UsersDetailsService from "./details/users.details.service";
import UsersDetailsAvatar from "./details/users.details.avatar.js";
import UniqueEmail from "./invitation/users.email.unique";
import Users from "./users";
import MenuUsers from "./menu/menu.users";
import UsersAlertPendingService from "./alert/users.alert.panding.service";
import UsersAlertService from "./alert/users.alert.service";
import PaymentStatusService from "./alert/payment.status.service"
import { AccountSettingsService } from "../../../../src/app/my-account/account-settings.service";

export default angular.module('CrazyWeb.Users', [])
    .directive("uniqueEmail", UniqueEmail)
    .component("usersInvitation", UsersInvitation)
    .component("usersDetails", UsersDetails)
    .component("usersEdit", UsersEdit)
    .component("usersAlert", UsersAlert)
    .component("usersInviteExist", UsersInviteExist)
    .component("usersInviteNew", UsersInviteNew)
    .component("usersDetailsAvatar", UsersDetailsAvatar)
    .component("users", Users)
    .component("menuUsers", MenuUsers)
    .service("Users", UsersService)
    .service("UsersDetails", UsersDetailsService)
    .service("UsersAlertPendingService", UsersAlertPendingService)
    .service("UsersAlertService", UsersAlertService)
    .service("PaymentStatusService", PaymentStatusService)
    .service("AccountSettingsService", AccountSettingsService).name
